import React from 'react';
import CognatesComponent from './cognates';
import CognatesNonSpanishComponent from './cognatesNonSpanish';

const CognatesHandler = (props) => {
  return (
    <>
      {props?.non_spanish_vocab ? <CognatesNonSpanishComponent {...props} /> : <CognatesComponent {...props} />}
    </>
  );
};

export default CognatesHandler;
